package app.nestbridge.feature.invitations.model

import app.nestbridge.app.context.identity.UserContext
import app.nestbridge.domain.identity.model.ProfessionalServiceType
import app.nestbridge.feature.careteam.model.TeamRelationshipRole
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class Invitation(
    val id: String,
    val status: InvitationStatus,

    // Inviter (always a Person)
    val inviterUserProfileId: String,
    val inviterDisplayName: String,
    val inviterOrganizationName: String? = null,
    val inviterOrganizationType: OrganizationType? = null,

    // Child context (display-only snapshot)
    val childId: String,
    val childDisplayName: String,

    // Team context (display-only snapshot)
    val teamId: String?,
    val teamType: ProfessionalServiceType?,

    // Proposed collaboration (NOT authority yet)
    val proposedTeamRole: TeamRelationshipRole,
    val grantsChildStewardship: Boolean,

    // Delivery
    val deliveryMethod: InvitationDeliveryMethod,
    val deliveryDestination: String?,

    // Audit
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
) {
    companion object {
        val empty = Invitation(
            id = "",
            status = InvitationStatus.PENDING,
            inviterUserProfileId = "",
            inviterDisplayName = "",
            inviterOrganizationName = null,
            inviterOrganizationType = null,
            childId = "",
            childDisplayName = "",
            teamId = null,
            teamType = null,
            proposedTeamRole = TeamRelationshipRole.OBSERVER,
            grantsChildStewardship = false,
            deliveryMethod = InvitationDeliveryMethod.EMAIL,
            deliveryDestination = null,
            createdAt = kotlin.time.Clock.System.now(),
            createdBy = "",
            modifiedAt = kotlin.time.Clock.System.now(),
            modifiedBy = "",
        )
    }
}

@Serializable
enum class InvitationStatus {
    PENDING,
    ACCEPTED,
    DECLINED,
    EXPIRED,
}

@Serializable
enum class OrganizationType {
    EARLY_INTERVENTION,
    PRIVATE_PRACTICE,
    SCHOOL_BASED,
    DAYCARE,
    ABA_CENTER,
    OTHER,
}

@Serializable
enum class InvitationDeliveryMethod {
    EMAIL,
    PHONE,
}
